// Façade logger ISOMORPHE — point d'import unique de tout le projet.
//
//   import logger from "@/services/logger"   (ou chemin relatif)
//   logger.debug("REDIS GET", id)
//   logger.info({ org: org.id }, "org résolue")
//   logger.error("fetch error", err)
//
// API commune : debug / info / warn / error / child(bindings).
//
// Sélection de l'implémentation selon l'environnement :
//  - SERVEUR (Node) → logger pino (services/logger/server.js) : JSON prod,
//    pretty dev, corrélation requestId/org via AsyncLocalStorage.
//  - NAVIGATEUR     → wrapper console léger (services/logger/client.js) :
//    silencieux en prod (warn/error only), verbeux en dev.
//
// IMPORTANT (bundling) : on NE fait PAS d'`import` statique de ./server. pino
// embarque des modules Node (worker_threads, fs, async_hooks) qui n'ont rien à
// faire dans le bundle client et gonfleraient/casseraient la build navigateur.
// On charge donc ./server via require() UNIQUEMENT quand `window` est absent.
// Webpack élimine la branche `typeof window === "undefined"` côté client, donc
// le require(./server) n'est jamais inclus dans le bundle navigateur.
//
// De même, on NE ré-exporte PAS ./requestContext ici : il dépend de async_hooks
// (Node uniquement). Le code serveur qui a besoin du contexte de requête
// (services/RouterService.js) importe "./logger/requestContext" DIRECTEMENT —
// jamais via cette façade — pour que le bundle client ne référence jamais
// async_hooks.

let impl;

if (typeof window === "undefined") {
    // Côté serveur Node : pino complet.
    // eslint-disable-next-line global-require
    impl = require("./server").default;
} else {
    // Côté navigateur : wrapper console.
    // eslint-disable-next-line global-require
    impl = require("./client").default;
}

export default impl;
